import {
  Box,
  Checkbox,
  Flex,
  Grid,
  Image,
  Text,
  keyframes,
} from '@chakra-ui/react'
import React, { useState } from 'react'
import { useKanguCargobr } from '../../../../../contexts/KanguCargobrContext'
import { formatPrice } from '../../../../../utils/formatPrice'
import { AiFillPlusCircle } from 'react-icons/ai'
import { FormLabel } from '@chakra-ui/form-control'

export function CardItem({ item, control, setItemCotado }) {
  const { handleCubagens, cubagens } = useKanguCargobr()
  const [show, setShow] = useState(false)

  console.log('cubagens, item', cubagens)

  function getCubagens(e) {
    handleCubagens(e, item, false)

    setItemCotado(false)
  }

  const animationCube = keyframes`
    0% {
        opacity: 0;
        transform: translateY(-10px);
        
        
    }
    100% {
        opacity: 1;
        transform: translateY(0px);
        
    }
`

  return (
    <Flex w="100%" flexDir={'column'} m="0 auto">
      <Grid
        templateColumns="3fr 1fr 1fr 1fr 2fr"
        textAlign="center"
        background="#e9e9e9"
        paddingBlock=".6rem"
        mb=".8rem"
      >
        <Flex m="0" textAlign="start" paddingLeft="1rem" gap={2}>
          <Text as="span" fontWeight="normal">
            Item {item.id + 1}
          </Text>
          <Text as="span" fontWeight="bold">
            Codprod.:
          </Text>
          <Text as="span" fontWeight="bold">
            {item.codigo}
          </Text>
        </Flex>
        <Text m="0">Qtd.</Text>
        <Text m="0">Valor unitário</Text>
        <Text m="0">Valor total</Text>
        <Text m="0">Selecione</Text>
      </Grid>
      <Grid
        templateColumns="3fr 1fr 1fr 1fr 2fr"
        textAlign="center"
        background="transparent"
        paddingBlock=".6rem"
        paddingInline="1rem"
        border="1px solid #cecece"
        position="relative"
      >
        <Flex fontSize="0.9375rem" color="#616162">
          <Image src={item.imagem} width="4.375rem" height="5.625rem" />
          <Flex flexDir="column" position="relative">
            <Text m="0" textAlign="start" paddingLeft="1rem">
              {item.nome.length > 20
                ? `${item.nome.substring(0, 20)}...`
                : item.nome}
            </Text>
            <Text m="0" textAlign="start" paddingLeft="1rem">
              Peso do item: {item.peso_item}kg
            </Text>
            <Flex
              alignItems="center"
              justifyContent="flex-start"
              paddingTop=".5rem"
            >
              <FormLabel
                m="0"
                textAlign="start"
                paddingLeft="1rem"
                fontWeight="bold"
                style={{ cursor: 'pointer' }}
                onClick={() => setShow(!show)}
              >
                Cubagem do pedido
              </FormLabel>
              <AiFillPlusCircle
                id={'cubagem'}
                size={20}
                onClick={() => setShow(!show)}
                style={{ marginLeft: '.5rem', cursor: 'pointer' }}
              />
            </Flex>
            <Flex
              flexDir={'column'}
              display={show ? 'flex' : 'none'}
              animation={`${animationCube} 0.5s`}
            >
              <Text m="0" textAlign="start" paddingLeft="1rem">
                Quantidade de caixas:{' '}
                <span style={{ fontWeight: 'bold' }}>
                  {item.quantidade_caixas}
                </span>
              </Text>
              <Text m="0" textAlign="start" paddingLeft="1rem">
                Medida da caixa:{' '}
                <span style={{ fontWeight: 'bold' }}>{item.medida}</span>
              </Text>
              <Text m="0" textAlign="start" paddingLeft="1rem">
                Quantidade de peças por caixa:{' '}
                <span style={{ fontWeight: 'bold' }}>
                  {item.quantidade_pecas}
                </span>
              </Text>
              <Text m="0" textAlign="start" paddingLeft="1rem">
                Peso por caixa:{' '}
                <span style={{ fontWeight: 'bold' }}>{item.peso_caixa}kg</span>
              </Text>
              <Text m="0" textAlign="start" paddingLeft="1rem">
                Peso total:{' '}
                <span style={{ fontWeight: 'bold' }}>{item.peso_total}kg</span>
              </Text>
            </Flex>
          </Flex>
        </Flex>
        <Text m="0">{item.qtd}</Text>
        <Text m="0">{formatPrice(item.vlr_unit)}</Text>
        <Text m="0">{formatPrice(item.vlr_total)}</Text>
        <Box ml={'1.5rem'}>
          <Checkbox
            name={`item${item.id}`}
            value={item.id}
            size="lg"
            isChecked={cubagens.some((cubagem) => cubagem.id === item.id)}
            colorScheme="green"
            borderColor="#cecece"
            control={control}
            onChange={(e) => getCubagens(e, item, false)}
          />
        </Box>
      </Grid>
    </Flex>
  )
}
